import Error404 from 'pages/error/Error404';
import SimpleSignIn from 'pages/authentication/SignIn';
import SimpleSignUp from 'pages/authentication/SignUp';
import SimpleSignOut from 'pages/authentication/SignOut';
import SimpleResetPassword from 'pages/authentication/ResetPassword';
import SimpleForgotPassword from 'pages/authentication/ForgotPassword';
import Home from 'pages/home';
import Contacts from 'pages/contacts';
import Class from 'pages/class';
import Courses from 'pages/courses';
import Pricing from 'pages/pricing';

export default [
  {
    path: '/',
    element: <Home />,
    private: true,
    open: false,
  },
  {
    path: '/contacts',
    element: <Contacts />,
    private: true,
    open: false,
  },
  {
    path: '/class',
    element: <Class />,
    private: true,
    open: false,
  },
  {
    path: '/courses',
    element: <Courses />,
    private: true,
    open: false,
  },
  {
    path: '/pricing',
    element: <Pricing />,
    private: true,
    open: false,
  },
  {
    path: '/sign-in',
    element: <SimpleSignIn />,
    private: false,
    open: false,
  },
  // Hidden as per requirements - registration not exposed in UI
  // {
  //   path: '/sign-up',
  //   element: <SimpleSignUp />,
  //   private: false,
  //   open: false,
  // },
  {
    path: '/sign-out',
    element: <SimpleSignOut />,
    private: false,
    open: false,
  },
  {
    path: '/forgot-password',
    element: <SimpleForgotPassword />,
    private: false,
    open: true,
  },
  {
    path: '/forgot-password',
    element: <SimpleResetPassword />,
    private: false,
    open: true,
  },
  {
    path: '/*',
    element: <Error404 />,
    private: false,
    open: true,
  },
];
